import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  updateField,
  updateFile,
  setConfig,
  resetConfig,
  resetFiles
} from "../redux/actions/configActions";

/**
 *  Populates the files object in the redux store with the images of the currently selected config.
 *  These images will then be displayed when viewing existing configs or templates
 * @param {*} initialValue the initial value of the field
 */
export function useConfigImages(isEditing) {
  const dispatch = useDispatch();
  const config = useSelector(state => {
    return state.configReducer.config;
  });

  useEffect(() => {
    if (isEditing) {
      const searchPattern = /(greenScreenBackground*|overlay*|gif*|strip*|path*|boomerang*|cover*|intro*|outro*|mosaic*|augmentedRealityMask*|slowMotionSoundEffect*)/;
      const items = Object.keys(config);

      for (let i = 0; i < items.length; i += 1) {
        // fetching picture in case it is one
        // starting with a test on whether the field is an array or not (all arrays hold pictures)
        if (Array.isArray(config[items[i]])) {
          const images = config[items[i]];
          images.forEach(image => {
            axios
              .get(
                process.env.REACT_APP_API_URL +
                  "resource/".concat(
                    config.eventId ? config.eventId : config.id,
                    "/",
                    image
                  )
              )
              .then(response => {
                // This will produce names like overlayImage1File, greenScreenBackground1File...
                const fileName = `${image.split("-")[0]}File`;
                dispatch(
                  updateFile({
                    [fileName]: response.config.url
                  })
                );
              });
          });
        } else if (items[i].search(searchPattern) !== -1) {
          // Item is a media object, we should test whether it's an image or a video.
          if (items[i] === "introVideo" || items[i] === "outroVideo") {
            axios
              .get(
                process.env.REACT_APP_API_URL +
                  "resource/".concat(
                    config.eventId ? config.eventId : config.id,
                    "/",
                    config[items[i]]
                  ),
                {
                  responseType: "video/mp4"
                }
              )
              .then(response => {
                const fileName = `${items[i]}File`;
                dispatch(
                  updateFile({
                    [fileName]: response.config.url
                  })
                );
              });
          } else if (items[i] == "slowMotionSoundEffect"){
            axios
            .get(
              process.env.REACT_APP_API_URL +
                "resource/".concat(
                  config.eventId ? config.eventId : config.id,
                  "/",
                  config[items[i]]
                ),
              {
                responseType: "audio/mpeg"
              }
            )
            .then(response => {
              const fileName = `${items[i]}File`;
              dispatch(
                updateFile({
                  [fileName]: response.config.url
                })
              );
            }).catch(err => 
              
             { console.log(err.message)});
          } 
          else {
            axios
              .get(
                process.env.REACT_APP_API_URL +
                  "resource/".concat(
                    config.eventId ? config.eventId : config.id,
                    "/",
                    config[items[i]]
                  )
              )
              .then(response => {
                const fileName = `${items[i]}File`;
                dispatch(
                  updateFile({
                    [fileName]: response.config.url
                  })
                );
              });
          }
        }
      }
    }
  }, [config._id]);
}

/**
 *  Prepares the configuration by either setting it in the redux store in case of an edit or by setting the machine ID in case of a config creation
 * @param {boolean} isEditing a flag that tells whether we're creating or editing
 * @param {*} machineId the machine's ID in case of a config edit, pass null in case of a template edit
 * @param {*} config the configuration (or template) to set
 */
export function useConfig(isEditing, machineId, config) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEditing) {
      dispatch(setConfig(config));
    } else if (machineId) {
      // If it's not an edit then we need to set the machine id in case of a config edit
      dispatch(
        updateField({
          machineId
        })
      );
    }
    dispatch(resetFiles());

    return () => {
      dispatch(resetConfig());
    };
  }, []);
}



// WEBPACK FOOTER //
// ./src/hooks/configHooks.js